// These constants are used for CSS transition and are defined in milliseconds
export const CHECKBOX_TRANSITION = 150
export const HOVER_TRANSITION = 200
export const SWITCHER_TRANSITION = 200
export const EXPAND_TRANSITION = 300
export const COLLAPSE_TRANSITION = 200
export const SIDEBAR_OPENING_TRANSITION = 200
export const CAROUSEL_TRANSITION = 700
export const SIDE_BANNER_TRANSITION = 700
export const SLIDER_TRANSITION = 1000
export const PULSE_TRANSITION = 1200
export const SNACKBAR_VISIBILITY_TRANSITION = 50
export const SNACKBAR_INVISIBILITY_TRANSITION = 150
export const TRIAL_BANNER_TRANSITION = 400

// These constants are used for CSS transition and are defined in seconds (for framer-motion library)
export const SNACKBAR_TRANSITION = 0.8
export const MODAL_TRANSITION = 0.2
export const HEADER_LOGO_TRANSITION = 0.3
export const SKELETON_LOADING_TRANSITION = 1.6

// Button state durations
export const BUTTON_SUBMITTING_MIN_DURATION = 2000
export const BUTTON_SUCCESS_MIN_DURATION = 1500
export const BUTTON_ERROR_MIN_DURATION = 3500
